import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchIds: string[];
}

export const useDownloadBulkBatchesReport = () => {
  return useMutation({
    mutationFn: async ({ batchIds }: HookProps) => {
      const result = await apiClient.batchesReports.downloadBulkBatchesReport.mutation({ body: { batchIds } });
      if (result.status !== 200) throw result.body;

      const href = window.URL.createObjectURL(result.body as Blob);
      const link = document.createElement('a');
      link.href = href;

      const [, fileName] = /attachment; filename="(.*)"/i.exec(result.headers.get('content-disposition'));

      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      toast.success('Successfully downloaded bulk batch reports!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading bulk batch reports!');
    },
  });
};
